import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./css/app.css";
import "./css/modern-styles.css";
import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Error404 } from "./components/auth";
import {
  AsesoriaContable,
  AuditoriaComunidad,
  Contacto,
  CreacionEmpresa,
  DeclaracionRenta,
  DiagnosticoTributario,
  Empresa,
  Home,
} from "./components/home";

class App extends Component {
  render = () => {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/servicios/creacion-empresa"
            element={<CreacionEmpresa />}
          />
          <Route
            path="/servicios/asesorias-contables"
            element={<AsesoriaContable />}
          />
          <Route
            path="/servicios/auditoria-comunidades"
            element={<AuditoriaComunidad />}
          />
          <Route
            path="/servicios/diagnostico-tributario"
            element={<DiagnosticoTributario />}
          />
          <Route
            path="/servicios/planificacion-renta-2027"
            element={<DeclaracionRenta />}
          />
          <Route path="/empresa" element={<Empresa />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    );
  };
}

export default App;
